module.exports = __webpack_public_path__ + "media/images/architect-text-img-cf1c35e25c1cd2ad4495316dcc3b3021.webp";